module.exports = __webpack_public_path__ + "img/logo.22923e5d.png";